<template>
    <div class="page-container page-container--height chat-visible teacher-lesson" :class="{'is-active' : state, 'sidebar-collapsed--chat' : sidebarStateRight, 'sidebar-collapsed' : sidebarStateLeft}">
<!--        <app-left-panel></app-left-panel>-->
        <a href="javascript:void(0);" class="close-sidebar"  @click.prevent="appp" :class="{'is-active' : state}">
            <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">
        </a>
        <div class="main-content" :class="{'is-active' : state}">

            <!--<div class="chat-head">
                <div class="chat-head__lesson">
                    <div class="d-flex">
                        <div class="head-icon">
                            <img :src="env.public_base + '/assets/images/teacher-item-icon.svg'" alt="">
                        </div>
                        <p class="messages__text messages__text&#45;&#45;empty">Math 5 class</p>
                    </div>

                    <div class="head-descr">
                        <div class="name">Course</div>
                        <div class="date">01.09.2019 - 31.05.2020</div>
                    </div>
                </div>
                <div class="chat-head_right">
                    <div class="btn-group-save" :class="{'is-active' : lessonTab == 'materials' && showControls}">
                        <button class="btn btn-blue">{{$t('save_changes')}}</button>
                        <button class="btn btn-blue-light">{{$t('cancel_2')}}</button>
                        <button class="btn btn-blue-light">{{$t('preview')}}</button>
                    </div>
                    <button type="button" class="btn btn-blue btn-icon icon-left" :class="{'is-active' : state}">
                        Чат
                        <i class="">
                            <img :src="env.public_base + '/assets/images/chats-icon.svg'" alt="">
                        </i>
                    </button>
                </div>



            </div>-->

            <div class="row">
                <div class="col-sm-12">
                    <!--<div class="card-student" :class="{'is-active' : lessonTab == 'checkstudent'}">
                        <div class="student-img">
                            <img :src="env.public_base + '/assets/images/student-photo.png'" alt="">
                        </div>
                        <div class="student-descr">
                            <div class="descr-position">Студент</div>
                            <div class="name-progress">
                                <div class="descr-name">Андрій Антоненко</div>
                                <div class="list-item_descr-progress">
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-success" role="progressbar"
                                             aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                                             style="width: 75%"><span class="sr-only">75% Complete (success)</span>
                                        </div>
                                    </div>
                                    <span>75%</span>
                                </div>
                            </div>
                            <div class="descr-check">
                                <div>Не перевірено робіт:</div>
                                <span>7</span>
                            </div>
                            <div class="descr-assessment">
                                <div>Річна оцінка:</div>
                                <span>9</span>
                            </div>
                        </div>
                    </div>-->

<!--                    <div class="tabs-container">
                        <button type="button" class="btn btn-link" :class="{'is-active' : lessonTab == 'courses'}" @click="lessonTab = 'courses'"><span>Курс</span></button>
                        <button type="button" class="btn btn-link" :class="{'is-active' : lessonTab == 'materials'}" @click="lessonTab = 'materials'" ><span>Матеріали</span></button>
                        <button type="button" class="btn btn-link" :class="{'is-active' : lessonTab == 'checkwork'}" @click="lessonTab = 'checkwork'">
                            <span>Перевірка робіт</span>
                            <div class="sub__notification sub__notification&#45;&#45;personal">2</div>
                        </button>
                        <button type="button" class="btn btn-link" :class="{'is-active' : lessonTab == 'checkstudent'}" @click="lessonTab = 'checkstudent'" ><span>Проверка ученика</span></button>
                    </div>

                    <div class="teacher-tab" v-if="lessonTab == 'courses'">
                        <div class="navigation">
                            <button class="btn btn-blue">
                                +Додати тему
                            </button>
                            <app-search-form :class="{'is-hidden': !showSearch}"
                                             :placeolder="$t('search')"></app-search-form>
                        </div>

                        <div class="teacher-accordions calcHeight">
                            <div class="accordion-item" v-for="item in array" :key="item.id">
                                <div class="accordion_head">
                                    <button class="head-name" @click="item.state = !item.state">
                                        Тема 3. Повторення і систематизація навчального матеріалу
                                        <div class="sub__notification sub__notification&#45;&#45;personal">2</div>
                                    </button>
                                    <div class="head-navigation">
                                        <button class="btn-blue-light">
                                            + Урок
                                        </button>
                                        <button class="btn-icon enable-lesson">
                                            <img :src="env.public_base + '/assets/images/eye-icon.svg'" alt="">
                                        </button>
                                        <button class="btn-icon sort-lesson up">
                                            <img :src="env.public_base + '/assets/images/arrow-long-up-icon.svg'" alt="">
                                        </button>
                                        <button class="btn-icon sort-lesson down">
                                            <img :src="env.public_base + '/assets/images/arrow-long-up-icon.svg'" alt="">
                                        </button>
                                        <button class="btn-icon delete-lesson">
                                            <img :src="env.public_base + '/assets/images/trash-icon.svg'" alt="">
                                        </button>
                                        <button class="btn-icon accordion-btn" @click="item.state = !item.state" :class="{'is-active' : item.state}">
                                            <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">
                                        </button>
                                    </div>
                                </div>

                                <div class="accordion_body" v-if="item.state">
                                    <div class="lesson_item" v-for="item in 4">
                                        <div class="lesson_item-name">
                                            <a href="javascript:void(0);">
                                                <img :src="env.public_base + '/assets/images/book-icon.svg'" alt="">
                                                <span>Урок 126-127. Арифметичні дії з натуральними та дробовими числами. Обчислення значень виразів</span>
                                            </a>
                                        </div>
                                        <div class="lesson_item-navigation">
                                            <button class="btn-icon enable-lesson" :disabled="acc">
                                                <img :src="env.public_base + '/assets/images/eye-icon.svg'" alt="">
                                            </button>
                                            <button class="btn-icon sort-lesson up">
                                                <img :src="env.public_base + '/assets/images/arrow-long-up-icon.svg'" alt="">
                                            </button>
                                            <button class="btn-icon sort-lesson down">
                                                <img :src="env.public_base + '/assets/images/arrow-long-up-icon.svg'" alt="">
                                            </button>
                                            <button class="btn-icon delete-lesson">
                                                <img :src="env.public_base + '/assets/images/trash-icon.svg'" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="teacher-tab materials calcHeight" v-if="lessonTab == 'materials'">
                        <div class="teacher-accordions">

                            <div class="accordion-item" :class="{'text-editor' : item.editor}" v-for="item in array_material" :key="item.id">
                                <div class="accordion_head" @click="openAccordion(item)">
                                    <div class="head-name" v-if="item.editor">
                                        Додаткова інформація про предмет
                                    </div>
                                    <div class="head-name" v-if="!item.editor">
                                        Рекомедовані підручники
                                    </div>
                                    <div class="head-right">
                                        <button class="accordion-btn" :class="{'is-active' : item.state}">
                                            <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">
                                        </button>
                                    </div>
                                </div>

                                <div class="accordion_body" v-if="item.state && item.editor">
                                    <div class="title">Зміст сторінки</div>
                                    <div class="text-editor">
                                        <img :src="env.public_base + '/assets/images/text-editor-img.png'" alt="" width="100%">
                                    </div>
                                </div>

                                <div class="accordion_body" v-if="item.state && !item.editor">
                                    <div class="lesson_item material_item">
                                        <div class="lesson_item-name">
                                            <svg class="clip-icon" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.8862 13.399C14.8862 12.466 14.4939 11.5647 13.8259 10.9074L7.66574 4.74721C7.25223 4.3231 6.67969 4.07924 6.08594 4.07924C4.91964 4.07924 4.00781 4.99107 4.00781 6.15737C4.00781 6.74051 4.25167 7.32366 4.67578 7.73716L9.02288 12.0843C9.0865 12.1479 9.17132 12.1903 9.25614 12.1903C9.4788 12.1903 10.0831 11.5859 10.0831 11.3633C10.0831 11.2785 10.0407 11.1936 9.97712 11.13L5.63002 6.78292C5.47098 6.61328 5.36496 6.39062 5.36496 6.15737C5.36496 5.74386 5.67243 5.44699 6.07534 5.44699C6.30859 5.44699 6.54185 5.54241 6.7115 5.70145L12.8717 11.8616C13.2746 12.2645 13.5396 12.8158 13.5396 13.399C13.5396 14.3002 12.8717 14.9682 11.9704 14.9682C11.3979 14.9682 10.8359 14.7031 10.433 14.3002L2.20536 6.06194C1.69643 5.55301 1.39955 4.86384 1.39955 4.14286C1.39955 2.64788 2.56585 1.42857 4.07143 1.42857C4.79241 1.42857 5.48159 1.74665 5.99051 2.24498L12.4157 8.6808C12.4794 8.74442 12.5642 8.78683 12.6596 8.78683C12.8823 8.78683 13.476 8.19308 13.476 7.97042C13.476 7.8856 13.4336 7.80078 13.37 7.73716L6.95536 1.31194C6.18136 0.548548 5.1423 0.113838 4.06083 0.113838C1.81306 0.113838 0.0424107 1.90569 0.0424107 4.15346C0.0424107 5.22433 0.487723 6.26339 1.24051 7.02679L9.4788 15.2545C10.1362 15.9118 11.0374 16.3147 11.9704 16.3147C13.6244 16.3147 14.8862 15.053 14.8862 13.399Z" fill="#21A9E1"/>
                                            </svg>

                                            <a href="javascript:void(0);">
                                                Математика 7 Мерзляк.pdf
                                            </a>
                                            <span>210 КБ</span>
                                            <button class="btn-icon delete-lesson">
                                                <img :src="env.public_base + '/assets/images/trash-icon.svg'" alt="">
                                            </button>
                                        </div>
                                    </div>
                                    <div class="lesson_item material_item">
                                        <div class="lesson_item-name">
                                            <svg class="clip-icon" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.8862 13.399C14.8862 12.466 14.4939 11.5647 13.8259 10.9074L7.66574 4.74721C7.25223 4.3231 6.67969 4.07924 6.08594 4.07924C4.91964 4.07924 4.00781 4.99107 4.00781 6.15737C4.00781 6.74051 4.25167 7.32366 4.67578 7.73716L9.02288 12.0843C9.0865 12.1479 9.17132 12.1903 9.25614 12.1903C9.4788 12.1903 10.0831 11.5859 10.0831 11.3633C10.0831 11.2785 10.0407 11.1936 9.97712 11.13L5.63002 6.78292C5.47098 6.61328 5.36496 6.39062 5.36496 6.15737C5.36496 5.74386 5.67243 5.44699 6.07534 5.44699C6.30859 5.44699 6.54185 5.54241 6.7115 5.70145L12.8717 11.8616C13.2746 12.2645 13.5396 12.8158 13.5396 13.399C13.5396 14.3002 12.8717 14.9682 11.9704 14.9682C11.3979 14.9682 10.8359 14.7031 10.433 14.3002L2.20536 6.06194C1.69643 5.55301 1.39955 4.86384 1.39955 4.14286C1.39955 2.64788 2.56585 1.42857 4.07143 1.42857C4.79241 1.42857 5.48159 1.74665 5.99051 2.24498L12.4157 8.6808C12.4794 8.74442 12.5642 8.78683 12.6596 8.78683C12.8823 8.78683 13.476 8.19308 13.476 7.97042C13.476 7.8856 13.4336 7.80078 13.37 7.73716L6.95536 1.31194C6.18136 0.548548 5.1423 0.113838 4.06083 0.113838C1.81306 0.113838 0.0424107 1.90569 0.0424107 4.15346C0.0424107 5.22433 0.487723 6.26339 1.24051 7.02679L9.4788 15.2545C10.1362 15.9118 11.0374 16.3147 11.9704 16.3147C13.6244 16.3147 14.8862 15.053 14.8862 13.399Z" fill="#21A9E1"/>
                                            </svg>

                                            <a href="javascript:void(0);">
                                                Математика 7 Мерзляк Задачник.pdf
                                            </a>
                                            <span>1 МБ</span>
                                            <button class="btn-icon delete-lesson">
                                                <img :src="env.public_base + '/assets/images/trash-icon.svg'" alt="">
                                            </button>
                                        </div>
                                    </div>
                                    <div class="lesson_item material_file">
                                        <form action="">
                                            <div class="form-field&#45;&#45;input-editor">
                                                <div class="file-upload file-field">
                                                    <input ref="fileInput" type="file" id="fileInput" name="photo">&lt;!&ndash; v-model="photo" name="photo"&ndash;&gt;
                                                    <p class="field__error" >{{ errors.first('photo') }}</p>
                                                </div>
                                                <button class="btn btn-blue" type="button">{{ $t('upload') }}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>-->

                    <div class="teacher-tab checkwork" v-if="lessonTab == 'checkwork'">
                        <div class="navigation">
                            <button class="btn btn-blue-light">
                                <img :src="env.public_base + '/assets/images/arrow-long-up-icon.svg'" alt="">
                                Експорт
                            </button>
                            <app-search-form :class="{'is-hidden': !showSearch}"
                                             :placeolder="$t('search')"></app-search-form>
                        </div>

                        <div class="teacher-accordions calcHeight">
                            <div class="accordion-title">
                                <div class="title-left">
                                    <button>
                                        <img :src="env.public_base + '/assets/images/gear-icon.svg'" alt="">
                                    </button>
                                    <span>ПІБ</span>
                                </div>
                                <div class="title-right">
                                    <div>На перевірку</div>
                                    <div>Річна оцінка</div>
                                </div>
                            </div>
                            <div class="accordion-item" v-for="item in array" :key="item.id">

                                <div class="accordion_head" @click="item.state = !item.state">
                                    <div class="head-name">
                                        <button class="accordion-btn" :class="{'is-active' : item.state}">
                                            <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">
                                        </button>
                                        7-А гуманітарний
                                    </div>
                                    <div class="head-right">
                                        <div>
                                            <div class="sub__notification sub__notification--personal">2</div>
                                        </div>
                                        <div></div>
                                    </div>
                                </div>

                                <div class="accordion_body" v-if="item.state">
                                    <div class="lesson_item" v-for="item in 6">
                                        <div class="lesson_item-name">
                                            <a href="javascript:void(0);">
                                                <span>Антоненко Андрій </span>
                                            </a>
                                        </div>
                                        <div class="lesson_item-right">
                                            <div>
                                                <div class="sub__notification sub__notification--personal">2</div>
                                            </div>
                                            <div>
                                                <div class="student-assessment">10</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="teacher-tab checkwork checkstudent" v-if="lessonTab == 'checkstudent'">
                        <div class="navigation">
                            <div class="navigation-left">
                                <button class="btn btn-gray-icon">
                                    <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">
                                    До статистики груп
                                </button>
                            </div>
                            <div class="navigation-right">
                                <button class="btn btn-blue-light">
                                    <img :src="env.public_base + '/assets/images/arrow-long-up-icon.svg'" alt="">
                                    Експорт
                                </button>
                                <app-search-form :class="{'is-hidden': !showSearch}" :placeolder="$t('search')"></app-search-form>
                            </div>

                        </div>

                        <div class="teacher-accordions calcHeight">
                            <div class="accordion-title">
                                <div class="title-left">
                                    <button>
                                        <img :src="env.public_base + '/assets/images/gear-icon.svg'" alt="">
                                    </button>
                                    <span>Урок №</span>
                                </div>
                                <div class="title-right">
                                    <div>На перевірку</div>
                                    <div>Бали</div>
                                    <div>Оцінка</div>
                                </div>
                            </div>
                            <div class="accordion-item" v-for="item in array" :key="item.id">

                                <div class="accordion_head" @click="item.state = !item.state">

                                    <div class="head-name">
                                        <button class="accordion-btn" :class="{'is-active' : item.state}">
                                            <img :src="env.public_base + '/assets/images/arrow-left-icon.svg'" alt="">
                                        </button>
                                        Урок 126. Арифметичні дії з натуральними та дробовими числами. Обчислення значень виразів
                                    </div>
                                    <div class="head-right">
                                        <div>
                                            <div class="sub__notification sub__notification--personal">2</div>
                                        </div>
                                        <div>
                                            68/100
                                        </div>
                                        <div>
                                            <div class="student-assessment">10</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion_body" v-if="item.state">
                                    <div class="lesson_item" v-for="item in 2">
                                        <div class="lesson_item-name">
                                            <a href="javascript:void(0);">
                                                <img :src="env.public_base + '/assets/images/board-icon.svg'" alt="">
                                                <span>Тест №1: Натуральні числа</span>
                                            </a>
                                        </div>
                                        <div class="lesson_item-right">
                                            <div>
                                                <div class="sub__notification sub__notification--personal">2</div>
                                            </div>
                                            <div>28/50</div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <div class="lesson_item" v-for="item in 2">
                                        <div class="lesson_item-name">
                                            <a href="javascript:void(0);">
                                                <img :src="env.public_base + '/assets/images/pen-icon.svg'" alt="">
                                                <span>Завдання № 1: Розв’язування прикладів              </span>
                                            </a>
                                        </div>
                                        <div class="lesson_item-right">
                                            <div>
                                                <div class="sub__notification sub__notification--personal">2</div>
                                            </div>
                                            <div>40/50</div>
                                            <div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>

        </div>

<!--        <div id="chat" class="right-sidebar" v-if="state" :class="{'is-active' : state}">
            <div class="sidebar_top">
                <div class="sidebar_top-header">
                    <img :src="env.public_base + '/assets/images/schedule-icon.svg'" alt="">
                    <span>
                        Розклад консультацій
                    </span>
                    <a href="javascript:void(0);" @click.prevent="appp2">
                        <img :src="env.public_base + '/assets/images/close-icon.svg'" alt="">
                    </a>
                </div>
                <div class="sidebar_top-body">
                    <div class="schedule-title">
                        четвер, 25 ТРАВНЯ 2019
                    </div>
                    <div class="schedule-list">
                        <a href="javascript:void(0);">7 класс - 14:30-15:30</a>
                        <a href="javascript:void(0);">8 класс - 15:30-16:30</a>
                    </div>
                </div>
            </div>

            <div class="sidebar_check">
                <div class="check-title">
                    <img :src="env.public_base + '/assets/images/warning-icon.svg'" alt="">
                    <span>{{$t('need_to_check')}}</span>
                </div>
                <div class="check-body">
                    <a href="javascript:void(0);">
                        Math 1 class
                        <span>7</span>
                    </a>
                    <a href="javascript:void(0);">
                        Math 3 class
                        <span>13</span>
                    </a>
                </div>
            </div>
            <app-languages></app-languages>
        </div>-->
    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanel from '../LeftPanel.vue';
    import RightPanel from '../RightPanel.vue';
    import ProfileForm from '../../../common_components/ProfileForm.vue';
    import SearchForm from '../SearchForm.vue';
    import env from '../../../env';
    import Languages from '../Languages';

    export default {
        data: function () {
            return {
                env,
                state: true,
                lessonTab: 'courses',
                acc: false,
                showSearch: true,
                array: [
                    {
                        id: 1,
                        state: false
                    },
                    {
                        id: 2,
                        state: false
                    },
                    {
                        id: 3,
                        state: false
                    }
                ],
                array_material: [
                    {
                        id: 1,
                        state: false,
                        editor: true
                    },
                    {
                        id: 2,
                        state: false,
                        editor: true
                    },
                    {
                        id: 3,
                        state: false,
                        editor: false

                    }
                ],
                showControls: false
            }
        },
        created(){

        },
        methods: {
            appp() {
                this.state = !this.state;
            },
            appp2(){
                this.state = false;
            },
            openAccordion(item){
                let array = this.array_material;
                array.forEach(el => {
                    if (el !== item) {
                        el.state = false;
                    }
                });
                this.array_material = array;
                item.state = !item.state;
                if (item.state && item.editor){
                    this.showControls = true;
                } else {
                    this.showControls = false;
                }
            }
        },
        computed: {
            ...mapGetters(['teacher', 'sidebarStateLeft',
                'sidebarStateRight'])
        },
        components: {
            appLeftPanel: LeftPanel,
            appRightPanel: RightPanel,
            appProfileForm: ProfileForm,
            appLanguages: Languages,
            appSearchForm: SearchForm,
        },
    }
</script>

<style scoped lang="sass">
    @import "../../../../sass/cabinet"
    @import "../../../../sass/teacherLesson"
    @import "../../../../sass/teacherCheckwork"
    @import "../../../../sass/studentStat"
    @import "../../../../sass/teacherMaterials"
</style>
